import { render } from "./Cx.vue?vue&type=template&id=96977b14&scoped=true&ts=true"
import script from "./cxHelper.ts?vue&type=script&lang=ts"
export * from "./cxHelper.ts?vue&type=script&lang=ts"

import "./Cx.vue?vue&type=style&index=0&id=96977b14&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96977b14"]])

export default __exports__